export class SheetFormSelect {
    constructor(optionalOptions = {}) {
        this._resets = document.querySelectorAll('.sheet [data-action="form-reset"]');
        if (!this._resets) {
            this.destructor();
            return true;
        }

        let inputs
        let value
        let def
        let rst

        this._resets.forEach((reset) => {
            reset.addEventListener("click", () => {
                inputs = reset.closest('.sheet-column').querySelectorAll('input')
                if (inputs) {
                    inputs.forEach((input) => {
                        value = input.dataset.value
                        def = input.dataset.default
                        rst = input.dataset.reset

                        input.val = value

                        if (rst) {
                            document.querySelector(rst).innerHTML = def
                        }
                    });
                }
            })
        })
    }

    destructor() {
        this._resets = null;
    }
}

export default new SheetFormSelect();